import {jsxs as _jsxs, jsx as _jsx} from "react/jsx-runtime"; function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }import styled from '@emotion/styled'

import graphql from 'babel-plugin-relay/macro'
import {memo} from 'react'
import {commitLocalUpdate, useFragment} from 'react-relay'


import EditingStatus from '~/components/EditingStatus/EditingStatus'
import {PALETTE} from '~/styles/paletteV3'
import IntegratedTaskContent from '../../../../components/IntegratedTaskContent'
import {TipTapEditor} from '../../../../components/promptResponse/TipTapEditor'
import TaskIntegrationLink from '../../../../components/TaskIntegrationLink'
import TaskWatermark from '../../../../components/TaskWatermark'
import useAtmosphere from '../../../../hooks/useAtmosphere'

import UpdateTaskMutation from '../../../../mutations/UpdateTaskMutation'
import {cardFocusShadow, cardHoverShadow, cardShadow, Elevation} from '../../../../styles/elevation'
import cardRootStyles from '../../../../styles/helpers/cardRootStyles'
import {Card} from '../../../../types/constEnums'
import isTaskArchived from '../../../../utils/isTaskArchived'
import isTaskPrivate from '../../../../utils/isTaskPrivate'
import {taskStatusLabels} from '../../../../utils/taskStatus'
import TaskFooter from '../OutcomeCardFooter/TaskFooter'
import OutcomeCardStatusIndicator from '../OutcomeCardStatusIndicator/OutcomeCardStatusIndicator'

const RootCard = styled('div')




(({isTaskHovered, isTaskFocused, isDragging, isTaskHighlighted}) => ({
  ...cardRootStyles,
  borderTop: 0,
  outline: isTaskHighlighted ? `2px solid ${PALETTE.SKY_300}` : 'none',
  padding: `${Card.PADDING} 0 0`,
  transition: `box-shadow 100ms ease-in`,
  // hover before focus, it matters
  boxShadow: isDragging
    ? Elevation.CARD_DRAGGING
    : isTaskHighlighted
      ? cardHoverShadow
      : isTaskFocused
        ? cardFocusShadow
        : isTaskHovered
          ? cardHoverShadow
          : cardShadow
}))

const ContentBlock = styled('div')({
  position: 'relative'
})

const StatusIndicatorBlock = styled('div')({
  display: 'flex'
})















const OutcomeCard = memo((props) => {
  const {
    addTaskChild,
    removeTaskChild,
    area,
    isTaskFocused,
    isTaskHovered,
    editor,
    handleCardUpdate,
    isAgenda,
    isDraggingOver,
    task: taskRef,
    useTaskChild
  } = props
  const task = useFragment(
    graphql`
      fragment OutcomeCard_task on Task @argumentDefinitions(meetingId: {type: "ID"}) {
        ...IntegratedTaskContent_task
        discussionId
        editors {
          userId
        }
        id
        integration {
          __typename
          ...TaskIntegrationLink_integration
        }
        status
        tags
        # grab userId to ensure sorting on connections works
        userId
        isHighlighted(meetingId: $meetingId)
        ...EditingStatus_task
        ...TaskFooter_task
      }
    `,
    taskRef
  )
  const isPrivate = isTaskPrivate(task.tags)
  const isArchived = isTaskArchived(task.tags)
  const toggleTag = (tagId) => {
    const {state, view} = editor
    const {doc, schema, tr} = state
    if (task.tags.includes(tagId)) {
      doc.descendants((node, pos) => {
        if (node.type.name === 'taskTag' && node.attrs.id === tagId) {
          tr.delete(pos, pos + node.nodeSize)
        }
      })
      view.dispatch(tr)
      const nextContent = JSON.stringify(editor.getJSON())
      UpdateTaskMutation(atmosphere, {updatedTask: {id: taskId, content: nextContent}}, {})
      return
    }
    // Create the mention node
    const mentionNode = schema.nodes.taskTag.create({id: tagId})

    // Insert the mention node at the end
    const transaction = tr.insert(doc.content.size, mentionNode)
    view.dispatch(transaction)
    const nextContent = JSON.stringify(editor.getJSON())
    UpdateTaskMutation(atmosphere, {updatedTask: {id: taskId, content: nextContent}}, {})
  }
  const {integration, status, id: taskId, isHighlighted, editors, discussionId} = task
  const atmosphere = useAtmosphere()
  const {viewerId} = atmosphere
  const otherEditors = editors.filter((editor) => editor.userId !== viewerId)
  const isEditing = editors.length > otherEditors.length
  const type = _optionalChain([integration, 'optionalAccess', _ => _.__typename])
  const statusTitle = `Card status: ${taskStatusLabels[status]}`
  const privateTitle = ', marked as #private'
  const archivedTitle = ', set as #archived'
  const statusIndicatorTitle = `${statusTitle}${isPrivate ? privateTitle : ''}${
    isArchived ? archivedTitle : ''
  }`
  const onFocusChange = (isFocus) => () => {
    if (!discussionId) return
    commitLocalUpdate(atmosphere, (store) => {
      _optionalChain([store, 'access', _2 => _2.get, 'call', _3 => _3(discussionId), 'optionalAccess', _4 => _4.setValue, 'call', _5 => _5(isFocus ? taskId : null, 'editingTaskId')])
    })
  }
  return (
    _jsxs(RootCard, {
      isTaskHovered: isTaskHovered,
      isTaskFocused: isTaskFocused,
      isDragging: !!isDraggingOver,
      isTaskHighlighted: !!isHighlighted,
 children: [
      _jsx(TaskWatermark, { type: type,} )
      , _jsxs(ContentBlock, { children: [
        _jsx(EditingStatus, {
          isTaskHovered: isTaskHovered,
          isArchived: isArchived,
          task: task,
          useTaskChild: useTaskChild,
 children: 
          _jsxs(StatusIndicatorBlock, { title: statusIndicatorTitle, children: [
            _jsx(OutcomeCardStatusIndicator, { status: isDraggingOver || status,} )
            , isPrivate && _jsx(OutcomeCardStatusIndicator, { status: "private",} )
            , isArchived && _jsx(OutcomeCardStatusIndicator, { status: "archived",} )
          ]})
        })
        , _jsx(IntegratedTaskContent, { task: task,} )
        , !type && (
          _jsx('div', {
            className: "cursor-text",
            onBlur: () => {
              removeTaskChild('root')
              setTimeout(handleCardUpdate)
            },
            onFocus: () => addTaskChild('root'),
 children: 
            _jsx(TipTapEditor, {
              className: "px-4",
              editor: editor,
              useLinkEditor: () => useTaskChild('editor-link-changer'),
              onBlur: onFocusChange(false),
              onFocus: onFocusChange(true),}
            )
          })
        )
        , _jsx(TaskIntegrationLink, { integration: integration || null,} )
        , _jsx(TaskFooter, {
          area: area,
          cardIsActive: isTaskFocused || isTaskHovered || isEditing,
          toggleTag: toggleTag,
          isAgenda: isAgenda,
          task: task,
          useTaskChild: useTaskChild,}
        )
      ]})
    ]})
  )
})

export default OutcomeCard
